export const company = {
  statusId: 1,
  companyId: 15,
  codigoUsuarioMaestro: 0,
};

export const companyForm = {
  id: 15, // si es 15: server status 500
};

export const paginationTopLimit = {
  limit: 9,
  topLimit: 999999999,
  limitPage: 1,
};
